var EventDetail;
(function (EventDetail) {
    document.addEventListener('ControllerReady', function () {
        var _a;
        const config = retrieveConfig(document);
        const $body = document.querySelector('body');
        const $modal = document.querySelector('.event-subscription-confirm-modal');
        let div = document.querySelector('.event-detail');
        let getServiceEndpoint = `/api/event-delete-subscription`; 
        const getAttributeListEndpoint = `/api/esb/user/getAttributeExtList?_format=form`;
        let currentEventID = retrieveEventID();
        let responseGetAttributeList = [];
        let eventsFromBack = getDataContainer();
        let singleEventDiv = document.querySelector('.singleEvent');
        let singleEventIscritto = singleEventDiv === null || singleEventDiv === void 0 ? void 0 : singleEventDiv.querySelector('.single-event-container-sub');
        let dummySingleEventSubs = singleEventDiv === null || singleEventDiv === void 0 ? void 0 : singleEventDiv.querySelector('.dummy-single-event-subs');
        let singleEventNoIscritto = singleEventDiv === null || singleEventDiv === void 0 ? void 0 : singleEventDiv.querySelector('.single-event-container-not');
        let dummySingleEventNSubs = singleEventDiv === null || singleEventDiv === void 0 ? void 0 : singleEventDiv.querySelector('.dummy-orario-single-event');
        let dummySingleEventOtherSubs = singleEventDiv === null || singleEventDiv === void 0 ? void 0 : singleEventDiv.querySelector('.dummy-single-event-subs-other');
        let bodyOra = document.querySelector('#body-ora');
        let bodyOraInOut = document.querySelector('#body-ora-in-out');
        let bodyData = document.querySelector('#body-data');
        let bodytitoloSt = document.querySelector('.titolo-desc-st');
        let bodyInpageTitoloSt = document.querySelector('.titolo-desc-page-st');
        let bodytitolo = document.querySelector('#titolo-desc');
        let bodyInpageTitolo = document.querySelector('#titolo-desc-page');
        let bodyDescrHTML = document.querySelector('#desc-subt');
        let bodyDescr = document.querySelector('#desc-subt-nt');
        let multiEventDiv = document.querySelector('.multiEvent');
        let dummyMultiEvents = multiEventDiv === null || multiEventDiv === void 0 ? void 0 : multiEventDiv.querySelector('.dummi.dummy-date-multi-event');
        let dummyMultiEventsReg = multiEventDiv === null || multiEventDiv === void 0 ? void 0 : multiEventDiv.querySelector('.dummi.dummy-date-multi-event-register');
        let dummyOraMultiEventsReg = multiEventDiv === null || multiEventDiv === void 0 ? void 0 : multiEventDiv.querySelector('.dummi.dummy-ora-multi-event-reg');
        let dummyOraMultiEvents = multiEventDiv === null || multiEventDiv === void 0 ? void 0 : multiEventDiv.querySelector('.dummi.dummy-ora-multi-event');
        let multiDateOraTitle = multiEventDiv === null || multiEventDiv === void 0 ? void 0 : multiEventDiv.querySelector('.right-data-selezionata-title');
        getUserAttributeList();
        document.querySelector('#nome-evento-modal').innerHTML = getEventName();
        if (document.querySelector('.discr')) {
            (_a = document.querySelector('.discr')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
                const $btnAccept = $modal === null || $modal === void 0 ? void 0 : $modal.querySelector('.accept');
                const $btnCancel = $modal === null || $modal === void 0 ? void 0 : $modal.querySelector('.no-accept');
                const $btnClose = $modal === null || $modal === void 0 ? void 0 : $modal.querySelector('.close');
                $modal === null || $modal === void 0 ? void 0 : $modal.classList.remove('d-none');
                $body === null || $body === void 0 ? void 0 : $body.classList.add('scrollLock');
                $btnAccept === null || $btnAccept === void 0 ? void 0 : $btnAccept.removeEventListener('click', handleAcceptClick);
                $btnAccept === null || $btnAccept === void 0 ? void 0 : $btnAccept.addEventListener('click', handleAcceptClick);
                $btnCancel === null || $btnCancel === void 0 ? void 0 : $btnCancel.addEventListener('click', handleCancelClick);
                $btnClose === null || $btnClose === void 0 ? void 0 : $btnClose.addEventListener('click', handleCloseClick);
            });
        }
        document.querySelectorAll("div[class^='singleEv dummi']").forEach((btn) => {
            btn.addEventListener('click', updateGUISingleEvent);
        });
        document.querySelectorAll('.iscr').forEach((btn) => {
            btn.addEventListener('click', subscription);
        });
        function retrieveConfig($wrapper) {
            let data = {
                url: '',
                config: {},
            };
            const $form = $wrapper && $wrapper.querySelector('.ep-config');
            if ($form) {
                try {
                    const url = $form.querySelector('[name="url"]').value;
                    const config = $form.querySelector('[name="config"]').value;
                    data = {
                        url: url.replace(/\/$/, ''),
                        config: JSON.parse(config),
                    };
                }
                catch (e) {
                    console.log('Error during retrieval of configuration for current service. %s', e);
                }
            }
            return data;
        }
        function handleAcceptClick() {
            disiscrizione();
        }
        function handleCancelClick() {
            $modal === null || $modal === void 0 ? void 0 : $modal.classList.add('d-none');
            $body === null || $body === void 0 ? void 0 : $body.classList.remove('scrollLock');
        }
        function handleCloseClick() {
            var _a, _b, _c, _d;
            (_b = (_a = document.querySelector('.event-subscription-confirm-modal')) === null || _a === void 0 ? void 0 : _a.querySelector('.container-modal.confirm')) === null || _b === void 0 ? void 0 : _b.classList.add('d-none');
            (_d = (_c = document.querySelector('.event-subscription-confirm-modal')) === null || _c === void 0 ? void 0 : _c.querySelector('.container-modal')) === null || _d === void 0 ? void 0 : _d.classList.remove('d-none');
            $modal === null || $modal === void 0 ? void 0 : $modal.classList.add('d-none');
            $body === null || $body === void 0 ? void 0 : $body.classList.remove('scrollLock');
        }
        function getEventName() {
            for (let i = 0; i < eventsFromBack.length; i++) {
                let event = eventsFromBack[i];
                if (event['event-id'] == currentEventID) {
                    return event['event-title'];
                }
            }
            return '';
        }
        function formatData(dataString) {
            const mesi = [
                'Gennaio',
                'Febbraio',
                'Marzo',
                'Aprile',
                'Maggio',
                'Giugno',
                'Luglio',
                'Agosto',
                'Settembre',
                'Ottobre',
                'Novembre',
                'Dicembre',
            ];
            const [giorno, meseNumero, anno] = dataString.split('-');
            const mese = mesi[parseInt(meseNumero) - 1];
            return `${giorno} ${mese}`;
        }
        function formatDataRange(startDate, endDate) {
            const months = {
                '01': 'Gennaio',
                '02': 'Febbraio',
                '03': 'Marzo',
                '04': 'Aprile',
                '05': 'Maggio',
                '06': 'Giugno',
                '07': 'Luglio',
                '08': 'Agosto',
                '09': 'Settembre',
                '10': 'Ottobre',
                '11': 'Novembre',
                '12': 'Dicembre',
            };
            const startDateParts = startDate.split('-');
            const startDay = parseInt(startDateParts[0]);
            const startMonth = parseInt(startDateParts[1]);
            const startYear = parseInt(startDateParts[2]);
            const startTimestamp = new Date(startYear, startMonth - 1, startDay);
            if (endDate) {
                const endDateParts = endDate.split('-');
                const endDay = parseInt(endDateParts[0]);
                const endMonth = parseInt(endDateParts[1]);
                const endYear = parseInt(endDateParts[2]);
                const endTimestamp = new Date(endYear, endMonth - 1, endDay);
                if (startMonth === endMonth) {
                    const monthName = months[String(startMonth).padStart(2, '0')];
                    return startDay + ' - ' + endDay + ' ' + monthName;
                }
                else {
                    const startMonthName = months[String(startMonth).padStart(2, '0')];
                    const endMonthName = months[String(endMonth).padStart(2, '0')];
                    return startDay + ' ' + startMonthName + ' - ' + endDay + ' ' + endMonthName;
                }
            }
            const monthName = months[String(startMonth).padStart(2, '0')];
            return startDay + ' ' + monthName;
        }
        function formatLabelDataTab(dataString) {
            const giorniSettimana = [
                'Domenica',
                'Lunedì',
                'Martedì',
                'Mercoledì',
                'Giovedì',
                'Venerdì',
                'Sabato',
            ];
            const mesiAnno = [
                'Gennaio',
                'Febbraio',
                'Marzo',
                'Aprile',
                'Maggio',
                'Giugno',
                'Luglio',
                'Agosto',
                'Settembre',
                'Ottobre',
                'Novembre',
                'Dicembre',
            ];
            const [giorno, mese, anno] = dataString.split('-');
            const dataFormattata = `${giorniSettimana[new Date(`${anno}-${mese}-${giorno}`).getDay()]} ${giorno} ${mesiAnno[mese - 1]}`;
            return dataFormattata;
        }
        function isRegister(eventId) {
            if (responseGetAttributeList == null || responseGetAttributeList.length == 0)
                return false;
            for (let i = 0; i < responseGetAttributeList.length; i++) {
                let attrib = responseGetAttributeList[i];
                if (attrib['datasetCode'] == eventId && attrib['unsubscriptionDate'] == null) {
                    return true;
                }
            }
            return false;
        }
        function updateGUISingleEvent(evt) {
            currentEventID = evt.target.getAttribute('data-id');
            const selectedTabs = document === null || document === void 0 ? void 0 : document.querySelectorAll('.tab-white-left.tab-selected');
            selectedTabs === null || selectedTabs === void 0 ? void 0 : selectedTabs.forEach((tab) => {
                tab.classList.remove('tab-selected');
            });
            const tabWhiteLeft = evt.target.querySelector('.tab-white-left');
            if (tabWhiteLeft) {
                tabWhiteLeft.classList.add('tab-selected');
            }
            updateFields(false, '');
        }
        function updateGUIMultiEvent(evt) {
            currentEventID = evt.target.getAttribute('data-id');
            let currentDate = evt.target.innerHTML;
            const selectedTabs = multiEventDiv === null || multiEventDiv === void 0 ? void 0 : multiEventDiv.querySelectorAll('.date-base-button');
            selectedTabs === null || selectedTabs === void 0 ? void 0 : selectedTabs.forEach((tab) => {
                tab.classList.remove('tab-selected');
            });
            const tabWhiteLeft = evt.target.querySelector('.date-base-button');
            if (tabWhiteLeft) {
                tabWhiteLeft.classList.add('tab-selected');
            }
            updateFields(true, currentDate);
        }
        function isActiveEvent(status) {
            return status == 1; 
        }
        function updateFields(condiction, currentDate) {
            var _a;
            for (let i = 0; i < eventsFromBack.length; i++) {
                let event = eventsFromBack[i];
                let obj;
                if (event['event-id'] == currentEventID ||
                    (event['event-id'] != currentEventID &&
                        currentDate == formatData(event['event-startdate']))) {
                    updatePartecipaButton(event);
                    if (bodyData) {
                        bodyData.innerHTML = formatDataRange(event['event-startdate'], event['event-enddate']);
                    }
                    if (bodyOra) {
                        let concOra;
                        if (event['event-endhour'] != '' && event['event-endhour'] != null) {
                            concOra = event['event-starthour'] + ' - ' + event['event-endhour'];
                        }
                        else {
                            concOra = event['event-starthour'];
                        }
                        bodyOra.innerHTML = concOra;
                    }
                    if (bodyDescrHTML) {
                        bodyDescrHTML.innerHTML = event['event-descr'];
                    }
                    else if (bodyDescr) {
                        bodyDescr.innerHTML = event['event-descr'];
                    }
                    if (bodyOraInOut) {
                        let concOra;
                        if (event['event-endhour'] != '' && event['event-endhour'] != null) {
                            concOra = event['event-starthour'] + ' - ' + event['event-endhour'];
                        }
                        else {
                            concOra = event['event-starthour'];
                        }
                        bodyOraInOut.innerHTML = concOra;
                    }
                    bodyInpageTitoloSt === null || bodyInpageTitoloSt === void 0 ? void 0 : bodyInpageTitoloSt.classList.add('hidden');
                    bodytitoloSt === null || bodytitoloSt === void 0 ? void 0 : bodytitoloSt.classList.add('hidden');
                    if (event['event-inpagetitle'].length === 0) {
                        bodytitolo === null || bodytitolo === void 0 ? void 0 : bodytitolo.classList.remove('hidden');
                        if (bodytitolo) {
                            bodytitolo.innerHTML = event['event-title'];
                            document.querySelector('#nome-evento-modal').innerHTML = event['event-title'];
                        }
                    }
                    else {
                        bodytitolo === null || bodytitolo === void 0 ? void 0 : bodytitolo.classList.add('hidden');
                        bodyInpageTitolo === null || bodyInpageTitolo === void 0 ? void 0 : bodyInpageTitolo.classList.remove('hidden');
                        if (bodyInpageTitolo) {
                            bodyInpageTitolo.innerHTML =
                                event['event-inpagetitle'];
                            document.querySelector('#nome-evento-modal').innerHTML = event['event-inpagetitle'];
                        }
                    }
                    if (condiction) {
                        var nodesToRemove = document === null || document === void 0 ? void 0 : document.querySelectorAll("div[class^='singleEv dummi']");
                        for (let i = 0; i < nodesToRemove.length; i++) {
                            (_a = nodesToRemove[i].parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(nodesToRemove[i]);
                        }
                        let first = true;
                        for (let j = 0; j < eventsFromBack.length; j++) {
                            let ev = eventsFromBack[j];
                            if (formatLabelDataTab(event['event-startdate']).trim() ==
                                formatLabelDataTab(ev['event-startdate']).trim()) {
                                if (isRegister(ev['event-id'])) {
                                    obj = dummyOraMultiEventsReg === null || dummyOraMultiEventsReg === void 0 ? void 0 : dummyOraMultiEventsReg.cloneNode(true);
                                    (obj === null || obj === void 0 ? void 0 : obj.querySelector('#ora-multi-ev')).innerHTML =
                                        ev['event-starthour'];
                                    (obj === null || obj === void 0 ? void 0 : obj.querySelector('#label-multi-ev')).innerHTML = ev['event-title'];
                                }
                                else {
                                    obj = dummyOraMultiEvents === null || dummyOraMultiEvents === void 0 ? void 0 : dummyOraMultiEvents.cloneNode(true);
                                    (obj === null || obj === void 0 ? void 0 : obj.querySelector('#ora-multi-ev')).innerHTML =
                                        ev['event-starthour'];
                                    (obj === null || obj === void 0 ? void 0 : obj.querySelector('#label-multi-ev')).innerHTML = ev['event-title'];
                                }
                                obj.setAttribute('data-id', ev['event-id']);
                                obj.className = 'singleEv dummi';
                                if (first) {
                                    first = false;
                                    obj.querySelector('.tab-white-left').classList.add('tab-selected');
                                }
                                obj.addEventListener('click', updateGUISingleEvent);
                                var nodeOr = multiEventDiv === null || multiEventDiv === void 0 ? void 0 : multiEventDiv.querySelector('.right-orari-wrap');
                                nodeOr === null || nodeOr === void 0 ? void 0 : nodeOr.appendChild(obj);
                            }
                        }
                        multiDateOraTitle.innerHTML = formatLabelDataTab(event['event-startdate']);
                        if (!isRegister(event['event-id'])) {
                            let strID = event['event-id'] +
                                '|' +
                                event['event-title'] +
                                '|' +
                                formatData(event['event-startdate']) +
                                '|' +
                                formatData(event['event-enddate']) +
                                '|' +
                                event['event-address'];
                            document.querySelector('.btn.red.register.iscr').setAttribute('id', strID);
                            document.querySelector('.btn.red.register.iscr').setAttribute('data-urltoredirect', event['event-registrationUrl']);
                        }
                        updateMoreEventInfo(event['event-id']);
                    }
                }
            }
        }
        function updateMoreEventInfo(ev) {
            const eventDiv = document.querySelector('.eventDiv-' + ev);
            if (!eventDiv)
                return;
            const getValue = (name) => { var _a, _b; return (_b = (_a = eventDiv.querySelector(`input[name="${name}"]`)) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ''; };
            const h1 = document.querySelector('.event-detail-titolo h1');
            const subtitle = document.querySelector('.event-detail-sottotitolo span');
            const address = document.querySelector('.address');
            const img = document.querySelector('.event-detail-immagine img');
            const btn = document.querySelector('.indicazioni-button');
            const city_name = document.querySelector('.city-name');
            if (h1)
                h1.innerHTML = getValue('event-title');
            if (subtitle)
                subtitle.textContent = getValue('event-subtitle');
            if (address)
                address.innerHTML = getValue('event-address');
            if (img)
                img.src = createGoogleString(getValue('event-address'), getValue('event-province'), getValue('event-city-name'), getValue('event-zipcode'), getValue('event-latitude'), getValue('event-longitude'), 13);
            if (btn)
                btn.href = createGoogleSearchUrl(getValue('event-city-name'), getValue('event-address'), getValue('event-zipcode'), getValue('event-city-name'));
            if (city_name)
                city_name.innerHTML = getValue('event-city-name');
        }
        function createGoogleSearchUrl(nome, indirizzo, cap, citta) {
            const query = encodeURIComponent(`${nome} ${indirizzo} ${cap} ${citta}`);
            return `https://www.google.com/maps/search/${query}`;
        }
        function createGoogleString(indirizzo, provincia, citta, cap, lat, long, zoom) {
            const key = `key=${config.config.gApi}`;
            const domain = "https://maps.googleapis.com/maps/api/staticmap?";
            const center = `center=${encodeURIComponent(indirizzo)},${citta},${cap},${provincia}`;
            const markers = `markers=color:red|label:C|${lat},${long}`;
            const zooms = `zoom=${zoom}`;
            const size = "size=600x400";
            const maptype = "maptype=roadmap";
            return `${domain}${center}&${zooms}&${size}&${maptype}&${markers}&${key}`;
        }
        function subscription(evt) {
            const param = evt.target.id;
            const url = evt.target.dataset.urltoredirect;
            const approvato = evt.target.getAttribute('data-attribute');
            let redirectUrl = null;
            const array = [];
            const cooperativeName = [];
            document.querySelectorAll('.cooperative').forEach((cooperativa) => {
                array.push(cooperativa.id);
                cooperativeName.push(cooperativa.innerHTML);
            });
            if (approvato == 1) {
                if (getCookie('session_info') == '') {
                    let descr = "L'evento è riservato ai soci di <b>";
                    descr +=
                        'Coop Alleanza 3.0, Coop Amiatina, Coop Liguria, Coop Lombardia, Coop Reno, Novacoop, Unicoop Etruria, Unicoop Firenze';
                    descr += '</b>';
                    showModalUnsub(true, descr, param);
                    return;
                }
                if (getCookie('session_coopId') == '44' ||
                    getCookie('session_coopId') == '17' ||
                    getCookie('session_coopId') == '36' ||
                    (getCookie('session_coopId') == '7' &&
                        (getCookie('session_info').split('|').length < 7 ||
                            getCookie('session_info').split('|')[6] == 'N'))) {
                    let descr = "L'evento è riservato ai soci di <b>";
                    descr +=
                        'Coop Alleanza 3.0, Coop Amiatina, Coop Liguria, Coop Lombardia, Coop Reno, Novacoop, Unicoop Etruria, Unicoop Firenze';
                    descr += '</b>';
                    showModalUnsub(false, descr, param);
                    return;
                }
                if (url) {
                    deleteCookie('event_info');
                    redirectUrl = url;
                }
                else {
                    setCookie('event_info', param);
                    redirectUrl = '/eventi/ringraziamento';
                }
            }
            else {
                if (url) {
                    deleteCookie('event_info');
                    redirectUrl = url;
                }
                else if (getCookie('session_info') == '') {
                    setCookie('event_info', param);
                    redirectUrl = '/auth/login';
                }
                else {
                    setCookie('event_info', param);
                    redirectUrl = '/eventi/ringraziamento';
                }
            }
            if (redirectUrl) {
                dataLayer.push({
                    event: 'registrazione_evento_start',
                    step_registrazione: 'click_partecipa',
                    eventCallback: function () {
                        window.location.href = redirectUrl;
                    },
                    eventTimeout: 500
                });
            }
        }
        function continuaIscrizione(eventId) {
            setCookie('event_info', eventId);
            window.location.href = '/eventi/ringraziamento';
        }
        function showModalUnsub(bool, description, param) {
            const $body = document.querySelector('body');
            const $modal = document.querySelector('.event-unsubscribe-modal');
            const $btnContinua = $modal === null || $modal === void 0 ? void 0 : $modal.querySelector('.accept'); 
            const $btnAltriEventi = $modal === null || $modal === void 0 ? void 0 : $modal.querySelector('.no-accept'); 
            const $descrizione = $modal === null || $modal === void 0 ? void 0 : $modal.querySelector('#description');
            const $title = $modal === null || $modal === void 0 ? void 0 : $modal.querySelector('.info');
            if (bool) {
                $btnContinua.innerHTML = 'Continua';
                $title.innerHTML = '';
            }
            $descrizione.innerHTML = description;
            $modal === null || $modal === void 0 ? void 0 : $modal.classList.remove('d-none');
            $body === null || $body === void 0 ? void 0 : $body.classList.add('scrollLock');
            $btnContinua === null || $btnContinua === void 0 ? void 0 : $btnContinua.removeEventListener('click', () => { });
            $btnContinua === null || $btnContinua === void 0 ? void 0 : $btnContinua.addEventListener('click', () => {
                $modal === null || $modal === void 0 ? void 0 : $modal.classList.add('d-none');
                $body === null || $body === void 0 ? void 0 : $body.classList.remove('scrollLock');
                if (bool)
                    continuaIscrizione(param);
            });
            $btnAltriEventi === null || $btnAltriEventi === void 0 ? void 0 : $btnAltriEventi.addEventListener('click', () => {
                $modal === null || $modal === void 0 ? void 0 : $modal.classList.add('d-none');
                $body === null || $body === void 0 ? void 0 : $body.classList.remove('scrollLock');
                window.location.href = '/eventi';
            });
        }
        function getUserAttributeList() {
            var coopId = getCookie('session_coopId');
            var token = getCookie('session_token');
            if (coopId == '' || token == '') {
                makeMenu();
                updateFields(false, '');
                return;
            }
            Fetch(getAttributeListEndpoint, {
                method: 'POST',
                data: { coopId, token },
                token: {
                    enable: true,
                },
            })
                .then((response) => {
                if (response.header.result == 'OK') {
                    responseGetAttributeList = response.payload.attributeList;
                    makeMenu();
                    updateFields(false, '');
                }
                else {
                    console.log('Handle errors');
                }
                div === null || div === void 0 ? void 0 : div.removeAttribute('data-spinner');
            })
                .catch((err) => {
                _flog(0, err, {
                    url: getAttributeListEndpoint,
                }, {});
                div === null || div === void 0 ? void 0 : div.removeAttribute('data-spinner');
            });
        }
        function retrieveEventID() {
            return document.querySelector('[name="eventData"]').value;
        }
        function setCookie(cname, cvalue) {
            document.cookie =
                cname + '=' + encodeURIComponent(cvalue) + ';domain=' + window.location.hostname + ';path=/;secure;';
        }
        function getCookie(cname) {
            let name = cname + '=';
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        }
        function deleteCookie(name) {
            if (getCookie(name) != '') {
                document.cookie =
                    name +
                        '=' +
                        ';domain=' +
                        window.location.hostname +
                        ';path=/' +
                        ';secure' +
                        ';expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            }
        }
        function disiscrizione() {
            var _a;
            (_a = document.querySelector('.event-subscription-confirm-modal')) === null || _a === void 0 ? void 0 : _a.setAttribute('data-spinner', 'mask');
            kettyDo(currentEventID);
        }
        function kettyDo(eventId) {
            let session_info = getCookie('session_info');
            let email = getCookie('session_email');
            let coopId = session_info.split('|')[0];
            let token = getCookie('session_token');
            Fetch(getServiceEndpoint, {
                method: 'POST',
                data: { eventId, coopId, token, email },
                token: {
                    enable: true,
                },
            })
                .then((response) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                try {
                    if (JSON.parse(response['data']).status == 'OK') {
                        getUserAttributeList();
                        (_a = document.querySelector('.event-subscription-confirm-modal')) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
                        (_b = document.querySelector('body')) === null || _b === void 0 ? void 0 : _b.classList.remove('scrollLock');
                    }
                    else if (JSON.parse(response['data']).status == 'Unauthorized') {
                        deleteCookie('session_token');
                        deleteCookie('session_info');
                        deleteCookie('session_coopId');
                        deleteCookie('session_email');
                        window.location.href = '/auth/login';
                    }
                    else {
                        document.querySelector("#unsubscribe-error-msg").innerHTML = JSON.parse(response['data']).message;
                        (_d = (_c = document.querySelector('.event-subscription-confirm-modal')) === null || _c === void 0 ? void 0 : _c.querySelector('.container-modal.confirm')) === null || _d === void 0 ? void 0 : _d.classList.remove('d-none');
                        (_f = (_e = document.querySelector('.event-subscription-confirm-modal')) === null || _e === void 0 ? void 0 : _e.querySelector('.container-modal')) === null || _f === void 0 ? void 0 : _f.classList.add('d-none');
                    }
                    (_g = document.querySelector('.event-subscription-confirm-modal')) === null || _g === void 0 ? void 0 : _g.removeAttribute('data-spinner');
                }
                catch (ex) {
                    console.error('Error: ', ex);
                    (_h = document.querySelector('.event-subscription-confirm-modal')) === null || _h === void 0 ? void 0 : _h.removeAttribute('data-spinner');
                }
                finally {
                    (_j = document.querySelector('.event-subscription-confirm-modal')) === null || _j === void 0 ? void 0 : _j.removeAttribute('data-spinner');
                }
            })
                .catch((err) => {
                var _a;
                console.error('Error: ', err);
                (_a = document.querySelector('.event-subscription-confirm-modal')) === null || _a === void 0 ? void 0 : _a.removeAttribute('data-spinner');
            });
        }
        function isMultiDate(events) {
            let startDates = [];
            for (let i = 0; i < events.length; i++) {
                let event = events[i];
                let startDate = event['event-startdate'];
                if (!startDates.includes(startDate)) {
                    startDates.push(startDate);
                }
            }
            return startDates.length > 1;
        }
        function isMultiOrario(events) {
            let startHours = [];
            for (let i = 0; i < events.length; i++) {
                let event = events[i];
                let starthour = event['event-starthour'];
                if (!startHours.includes(starthour)) {
                    startHours.push(starthour);
                }
            }
            return startHours.length > 1;
        }
        function getDataContainer() {
            const form = document.querySelector('.eventsContainer');
            if (form) {
                const eventDivs = form === null || form === void 0 ? void 0 : form.querySelectorAll("[class^='eventDiv-']");
                let events = [];
                eventDivs.forEach((div) => {
                    let inputs = div.getElementsByTagName('input');
                    let event = {};
                    for (let i = 0; i < inputs.length; i++) {
                        let input = inputs[i];
                        let name = input.getAttribute('name');
                        event[name] = input.value;
                    }
                    events.push(event);
                });
                return events;
            }
            return '';
        }
        function makeMenu() {
            if (isMultiDate(eventsFromBack)) {
                console.log('MULTI DATE');
                let objDt;
                let objOr;
                multiDateOraTitle.innerHTML = formatLabelDataTab(eventsFromBack[0]['event-startdate']);
                for (let i = 0; i < eventsFromBack.length; i++) {
                    let event = eventsFromBack[i];
                    if (duplicateEvent(formatLabelDataTab(event['event-startdate']), event['event-id'])) {
                        for (let j = 0; j < eventsFromBack.length; j++) {
                            let ev = eventsFromBack[j];
                            if (formatLabelDataTab(event['event-startdate']).trim() ==
                                formatLabelDataTab(ev['event-startdate']).trim() &&
                                event['event-id'] != ev['event-id']) {
                                if (isRegister(event['event-id'])) {
                                    objOr = dummyOraMultiEventsReg === null || dummyOraMultiEventsReg === void 0 ? void 0 : dummyOraMultiEventsReg.cloneNode(true);
                                }
                                else {
                                    objOr = dummyOraMultiEvents === null || dummyOraMultiEvents === void 0 ? void 0 : dummyOraMultiEvents.cloneNode(true);
                                }
                                (objOr === null || objOr === void 0 ? void 0 : objOr.querySelector('#ora-multi-ev')).innerHTML =
                                    ev['event-starthour'];
                                (objOr === null || objOr === void 0 ? void 0 : objOr.querySelector('#label-multi-ev')).innerHTML =
                                    ev['event-title'];
                                objOr.setAttribute('data-id', ev['event-id']);
                                objOr.className = 'singleEv dummi';
                                if (first()) {
                                    objOr
                                        .querySelector('.tab-white-left')
                                        .classList.add('tab-selected');
                                }
                                objOr.addEventListener('click', updateGUISingleEvent);
                                var nodeOr = multiEventDiv === null || multiEventDiv === void 0 ? void 0 : multiEventDiv.querySelector('.right-orari-wrap');
                                nodeOr === null || nodeOr === void 0 ? void 0 : nodeOr.appendChild(objOr);
                            }
                        }
                        continue;
                    }
                    if (checkIsRegisterEvent(eventsFromBack, event['event-startdate'])) {
                        console.log('Reg');
                        objDt = dummyMultiEventsReg === null || dummyMultiEventsReg === void 0 ? void 0 : dummyMultiEventsReg.cloneNode(true);
                        (objDt === null || objDt === void 0 ? void 0 : objDt.querySelector('#data-multi-event-label')).innerHTML =
                            formatLabelDataTab(event['event-startdate']);
                        if (i == 0) {
                            let first = true;
                            for (let j = 0; j < eventsFromBack.length; j++) {
                                let ev = eventsFromBack[j];
                                if (formatLabelDataTab(event['event-startdate']).trim() ==
                                    formatLabelDataTab(ev['event-startdate']).trim() &&
                                    event['event-id'] != ev['event-id']) {
                                    objOr = dummyOraMultiEventsReg === null || dummyOraMultiEventsReg === void 0 ? void 0 : dummyOraMultiEventsReg.cloneNode(true);
                                    (objOr === null || objOr === void 0 ? void 0 : objOr.querySelector('#ora-multi-ev')).innerHTML = ev['event-starthour'];
                                    (objOr === null || objOr === void 0 ? void 0 : objOr.querySelector('#label-multi-ev')).innerHTML = ev['event-title'];
                                    objOr.setAttribute('data-id', ev['event-id']);
                                    objOr.className = 'singleEv dummi';
                                    if (first) {
                                        first = false;
                                        objOr
                                            .querySelector('.tab-white-left')
                                            .classList.add('tab-selected');
                                    }
                                    objOr.addEventListener('click', updateGUISingleEvent);
                                    var nodeOr = multiEventDiv === null || multiEventDiv === void 0 ? void 0 : multiEventDiv.querySelector('.right-orari-wrap');
                                    nodeOr === null || nodeOr === void 0 ? void 0 : nodeOr.appendChild(objOr);
                                }
                            }
                        }
                    }
                    else {
                        objDt = dummyMultiEvents === null || dummyMultiEvents === void 0 ? void 0 : dummyMultiEvents.cloneNode(true);
                        (objDt === null || objDt === void 0 ? void 0 : objDt.querySelector('#data-multi-event-label')).innerHTML =
                            formatLabelDataTab(event['event-startdate']);
                        if (i == 0) {
                            let first = true;
                            for (let j = 0; j < eventsFromBack.length; j++) {
                                let ev = eventsFromBack[j];
                                if (formatLabelDataTab(event['event-startdate']).trim() ==
                                    formatLabelDataTab(ev['event-startdate']).trim() &&
                                    event['event-id'] != ev['event-id']) {
                                    objOr = dummyOraMultiEvents === null || dummyOraMultiEvents === void 0 ? void 0 : dummyOraMultiEvents.cloneNode(true);
                                    (objOr === null || objOr === void 0 ? void 0 : objOr.querySelector('#ora-multi-ev')).innerHTML = ev['event-starthour'];
                                    (objOr === null || objOr === void 0 ? void 0 : objOr.querySelector('#label-multi-ev')).innerHTML = ev['event-title'];
                                    objOr.setAttribute('data-id', ev['event-id']);
                                    objOr.className = 'singleEv dummi';
                                    if (first) {
                                        first = false;
                                        objOr
                                            .querySelector('.tab-white-left')
                                            .classList.add('tab-selected');
                                    }
                                    objOr.addEventListener('click', updateGUISingleEvent);
                                    var nodeOr = multiEventDiv === null || multiEventDiv === void 0 ? void 0 : multiEventDiv.querySelector('.right-orari-wrap');
                                    nodeOr === null || nodeOr === void 0 ? void 0 : nodeOr.appendChild(objOr);
                                }
                            }
                        }
                    }
                    objDt.setAttribute('data-id', event['event-id']);
                    objDt.className = 'multiEv dummi';
                    objDt.addEventListener('click', updateGUIMultiEvent);
                    if (i == 0) {
                        objDt.querySelector('.date-base-button').classList.add('tab-selected');
                    }
                    var nodeDt = multiEventDiv === null || multiEventDiv === void 0 ? void 0 : multiEventDiv.querySelector('.date-wrap');
                    nodeDt === null || nodeDt === void 0 ? void 0 : nodeDt.appendChild(objDt);
                }
                (multiEventDiv === null || multiEventDiv === void 0 ? void 0 : multiEventDiv.querySelector('.multiEv.dummi')).click();
            }
            else if (isMultiOrario(eventsFromBack)) {
                console.log('MULTI ORARIO');
                let obj;
                let node;
                if (existsRegistedEvent(eventsFromBack)) {
                    singleEventIscritto === null || singleEventIscritto === void 0 ? void 0 : singleEventIscritto.classList.remove('hidden');
                    node = singleEventIscritto === null || singleEventIscritto === void 0 ? void 0 : singleEventIscritto.querySelector('.flex-orari-wrap');
                }
                else {
                    singleEventNoIscritto === null || singleEventNoIscritto === void 0 ? void 0 : singleEventNoIscritto.classList.remove('hidden');
                    node = singleEventNoIscritto === null || singleEventNoIscritto === void 0 ? void 0 : singleEventNoIscritto.querySelector('.flex-orari-wrap');
                }
                for (var i = 0; i < eventsFromBack.length; i++) {
                    let event = eventsFromBack[i];
                    if (isRegister(event['event-id'])) {
                        obj = dummySingleEventSubs === null || dummySingleEventSubs === void 0 ? void 0 : dummySingleEventSubs.cloneNode(true);
                        (obj === null || obj === void 0 ? void 0 : obj.querySelector('#ora-event-subs')).innerHTML =
                            event['event-starthour'];
                        (obj === null || obj === void 0 ? void 0 : obj.querySelector('#ora-label-event-subs')).innerHTML =
                            event['event-title'];
                        obj.setAttribute('data-id', event['event-id']);
                        obj.className = 'singleEv dummi';
                        obj.addEventListener('click', updateGUISingleEvent);
                        node === null || node === void 0 ? void 0 : node.appendChild(obj);
                    }
                    else if (checkIsRegisterEvent(eventsFromBack, event['event-startdate'])) {
                        obj = dummySingleEventOtherSubs === null || dummySingleEventOtherSubs === void 0 ? void 0 : dummySingleEventOtherSubs.cloneNode(true);
                        (obj === null || obj === void 0 ? void 0 : obj.querySelector('#ora-event-subs-oth')).innerHTML =
                            event['event-starthour'];
                        (obj === null || obj === void 0 ? void 0 : obj.querySelector('#ora-label-event-subs-oth')).innerHTML =
                            event['event-title'];
                        obj.setAttribute('data-id', event['event-id']);
                        obj.className = 'singleEvOth dummi';
                        obj.addEventListener('click', updateGUISingleEvent);
                        var nodo = singleEventIscritto === null || singleEventIscritto === void 0 ? void 0 : singleEventIscritto.querySelector('#single-event-multi-hour-wrap');
                        nodo === null || nodo === void 0 ? void 0 : nodo.appendChild(obj);
                    }
                    else {
                        obj = dummySingleEventNSubs === null || dummySingleEventNSubs === void 0 ? void 0 : dummySingleEventNSubs.cloneNode(true);
                        (obj === null || obj === void 0 ? void 0 : obj.querySelector('#ora-event-num')).innerHTML =
                            event['event-starthour'];
                        (obj === null || obj === void 0 ? void 0 : obj.querySelector('#ora-event-label')).innerHTML =
                            event['event-title'];
                        obj.setAttribute('data-id', event['event-id']);
                        obj.className = 'singleEv dummi';
                        obj.addEventListener('click', updateGUISingleEvent);
                        node === null || node === void 0 ? void 0 : node.appendChild(obj);
                    }
                }
                let first = node.querySelector('.singleEv.dummi').querySelector('.tab-white-left');
                first.classList.add('tab-selected');
                first.parentNode.click();
            }
        }
        function checkIsRegisterEvent(collection, date) {
            let test = false;
            collection.forEach((event) => {
                if (isRegister(event['event-id']) &&
                    event['event-startdate'].trim() === date.trim()) {
                    console.log('TEST: ', true);
                    test = true;
                }
            });
            return test;
        }
        function existsRegistedEvent(collection) {
            let test = false;
            collection.forEach((event) => {
                if (isRegister(event['event-id'])) {
                    console.log('TEST: ', true);
                    test = true;
                }
            });
            return test;
        }
        function updatePartecipaButton(event) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (isRegister(event['event-id'])) {
                (_a = document.querySelector('.discr')) === null || _a === void 0 ? void 0 : _a.classList.remove('hidden');
                (_b = document.querySelector('.iscr')) === null || _b === void 0 ? void 0 : _b.classList.add('hidden');
                (_c = document.querySelector('.vai-eventi')) === null || _c === void 0 ? void 0 : _c.classList.remove('d-none');
            }
            else {
                (_d = document.querySelector('.discr')) === null || _d === void 0 ? void 0 : _d.classList.add('hidden');
                if (event['event-registrationButtonVisible'] != 0) {
                    (_e = document.querySelector('.iscr')) === null || _e === void 0 ? void 0 : _e.classList.remove('hidden');
                }
                (_f = document.querySelector('.vai-eventi')) === null || _f === void 0 ? void 0 : _f.classList.add('d-none');
                let strID = event['event-id'] +
                    '|' +
                    event['event-title'] +
                    '|' +
                    formatData(event['event-startdate']) +
                    '|' +
                    formatData(event['event-enddate']) +
                    '|' +
                    event['event-address'];
                document.querySelector('.btn.red.register.iscr').setAttribute('id', strID);
                document.querySelector('.btn.red.register.iscr').setAttribute('data-urltoredirect', event['event-registrationUrl']);
            }
            let is_active_event = isActiveEvent(event['event-status']);
            if (is_active_event) {
                (_g = document.querySelector('.btn.red.register.iscr')) === null || _g === void 0 ? void 0 : _g.removeAttribute('disabled');
            }
            else {
                (_h = document.querySelector('.btn.red.register.iscr')) === null || _h === void 0 ? void 0 : _h.setAttribute('disabled', '');
            }
            var badgeCssClass = getBadge(event['event-status']);
            var badgeEventStatus = document.querySelectorAll('.status-badge')[0];
            badgeEventStatus.classList.remove('success');
            badgeEventStatus.classList.remove('warning');
            badgeEventStatus.classList.remove('danger');
            badgeEventStatus.innerHTML = '';
            badgeEventStatus.classList.add(badgeCssClass);
            badgeEventStatus.innerHTML = event['event-status-desc'];
        }
        function getBadge(statusId) {
            const statusMap = {
                1: 'success',
                2: 'warning',
                3: 'danger',
                4: 'danger',
                5: 'warning',
                6: 'danger',
                7: 'danger',
                8: 'warning' 
            };
            const cssClass = statusMap[statusId] || 'warning';
            return cssClass;
        }
        function first() {
            let div = multiEventDiv === null || multiEventDiv === void 0 ? void 0 : multiEventDiv.querySelector('.right-orari-wrap');
            let nodes = div === null || div === void 0 ? void 0 : div.querySelectorAll('.singleEv.dummi');
            return (nodes === null || nodes === void 0 ? void 0 : nodes.length) === 0;
        }
        function duplicateEvent(eventDateInStr, eventId) {
            let nodes = document.querySelectorAll('.multiEv');
            for (let i = 0; i < nodes.length; i++) {
                if (nodes[i].querySelector('#data-multi-event-label').innerHTML.trim() ===
                    eventDateInStr.trim()) {
                    return true;
                }
            }
            return false;
        }
    });
})(EventDetail || (EventDetail = {}));
